<div class="p-grid p-fluid">
  <!--ADDRESS ASSIGNMENT -->
  <div id="addressAssignment" class="p-col-12 p-md-5 p-lg-5">
      <app-kpi [cModel]="chartModelAddressAssignment"  [cDataLabels]="dataLabelsAddressAssignment" [cDataModel]="arrAddressAssignment" [cOptions]="dataOptionsAddressAssignment" >
      </app-kpi>
  </div>
  <!--CALLS COMPLETED -->
  <div class="p-col-12 p-md-7">
      <app-kpi [cModel]="chartModelCallsCompleted" [cDataLabels]="dataLabelsCallsCompleted" [cDataModel]="arrCallsCompleted" [cOptions]="dataOptionsCallsCompleted">
      </app-kpi>
  </div>
</div>
<div class="p-grid p-fluid">
  <div class="p-col-12 p-md-5 p-lg-5">

  </div>
  <div class="p-col-12 p-md-7">

  </div>
</div>
<div class="p-grid p-fluid">
  <!--ADDRESSES -->
  <div class="p-col-12 p-md-5 p-lg-5">
      <app-kpi [cModel]="chartModelAddresses" [cDataLabels]="dataLabelsAddresses" [cDataModel]="arrAddresses" [cOptions]="dataOptionsAddresses">
      </app-kpi>
  </div>
  <!--PENDS CREATED -->
  <div class="p-col-12 p-md-7">
      <app-kpi [cModel]="chartModelPendsCreated" [cDataLabels]="dataLabelsPendsCreated" [cDataModel]="arrPendsCreated" [cOptions]="dataOptionsPendsCreated">
      </app-kpi>
  </div>
</div>